module.exports = __webpack_public_path__ + "static/img/img-features-feature-2-game-1@2x.70c40e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-2-game-1@2x.png
// module id = UKY0
// module chunks = 18